export default "__VITE_ASSET__f60562c7__"